<div *ngIf="licenses()" class="license-container">
    <h2>License info</h2>

    <div class="license-section active-license">
        <h3>Actual license</h3>
        <div class="license-card">
            <p><strong>Type:</strong> {{ active()!.type }}</p>
            <p><strong>Expiration:</strong>{{ active()!.expiration }}</p>
            <details *ngIf="active()!.additionalInfo" class="debug-info">
                <summary>Full info</summary>
                <pre>
                    {{ active()!.additionalInfo }}
                </pre>
            </details>
        </div>
    </div>

    <div class="license-section server-license" *ngIf="serverAdded() != null">
        <h3>Server license</h3>
        <div class="license-card">
            <p><strong>Type:</strong> {{ serverAdded()!.type }}</p>
            <p><strong>Expiration:</strong>{{ serverAdded()!.expiration }}</p>
            <details *ngIf="serverAdded()!.additionalInfo" class="debug-info">
                <summary>Full info</summary>
                <pre>
                    {{ serverAdded()!.additionalInfo }}
                </pre>
            </details>
        </div>
    </div>

    <div class="license-section purchases">
        <h3>Purchases</h3>
        <div *ngIf="purchases().length > 0" class="purchase-list">
            <div *ngFor="let item of purchases()" class="license-card purchase">
                <p><strong>Type:</strong> {{ item!.type }}</p>
                <p><strong>Expiration:</strong>{{ item!.expiration }}</p>
                <details *ngIf="item!.additionalInfo" class="debug-info">
                    <summary>Full info</summary>
                    <pre>
                    {{ item!.additionalInfo }}
                </pre>
                </details>
            </div>
        </div>
        <div *ngIf="purchases.length == 0" class="no-license">
            <em>No purchases</em>
        </div>
    </div>

    <div class="license-section server-license">
        <add-server-license [iid]="iid()"></add-server-license>
    </div>
</div>